import { RoleType } from '@ace-clublabs/common-membership-api-types';
import { TooltipModal, TooltipModalContentProps, TooltipModalSubContent } from '../TooltipModal';
import { IRole } from '@lib/types/dist/INewMembershipInfo';

export interface AdditionalMemberTooltipPros {
  memAddOnTooltipInfo: TooltipModalContentProps | null;
  setMemAddOnTooltipInfo: Function;
  roles: IRole[];
}
export const AdditionalMemberTooltip: (props: AdditionalMemberTooltipPros) => JSX.Element = ({
  memAddOnTooltipInfo,
  setMemAddOnTooltipInfo,
  roles,
}) => {
  const AS = roles.find((role) => role.role === RoleType.ASSOCIATE);
  const AD = roles.find((role) => role.role === RoleType.ADULT_ASSOCIATE);
  const DE = roles.find((role) => role.role === RoleType.DEPENDENT);

  return (
    <>
      <TooltipModal
        tooltipTitle={memAddOnTooltipInfo?.tooltipTitle ?? ''}
        showModal={!!memAddOnTooltipInfo}
        closeModal={() => setMemAddOnTooltipInfo(null)}
      >
        {AD ? (
          <TooltipModalSubContent
            subtitle="Adult"
            tooltipContent={`An Adult Associate must reside in your household. There is a limit of ${AD.maximumAllowed} Adult Associate per household.`}
          ></TooltipModalSubContent>
        ) : (
          <></>
        )}
        {DE ? (
          <TooltipModalSubContent
            subtitle="Dependent"
            // @ts-ignore
            tooltipContent={
              <>
                Dependent Associates must be under {DE.maximumAge + 1} years old <strong>and</strong> either live with
                you or be a full-time student away at school. There is a limit of {DE.maximumAllowed} Dependent
                Associates per household.
              </>
            }
          ></TooltipModalSubContent>
        ) : (
          <></>
        )}
        {AS ? (
          <TooltipModalSubContent
            subtitle="Associate"
            // @ts-ignore
            tooltipContent={`An Associate member must reside in your household. There is a limit of ${AS.maximumAllowed} Associate members per primary membership.`}
          ></TooltipModalSubContent>
        ) : (
          <></>
        )}
      </TooltipModal>
    </>
  );
};
